export enum StoreWidgetState {
  REGISTERED = 'REGISTERED',
  GLOBAL_INITIALIZATION = 'GLOBAL_INITIALIZATION',
  INITIALIZATION = 'INITIALIZATION',
  ERROR = 'ERROR',
  COMPLETED = 'COMPLETED',
  TRIGGER_RUNNING = 'TRIGGER_RUNNING'
}
